'use client';

import './index.css';

import { storyblokEditable } from '@storyblok/react';
import classnames from 'classnames';
import { useState } from 'react';

import { Image } from '@/components/image';
import { MaxWidth } from '@/components/max-width';

import { isImage } from '@/helpers/image';
import { hasText, render } from '@/helpers/storyblok/rich-text';

export const WeekClient = ({ blok }) => {
  const items = blok.items || [];
  const [current, setCurrent] = useState(0);

  if (items.length === 0) {
    return null;
  }

  return (
    <div {...storyblokEditable(blok)} className="week">
      <MaxWidth>
        <div className="week__inner">
          <ul className="week__list">
            {items.map((item, index) => (
              <li key={item._uid} className="week__list__item">
                <button
                  {...storyblokEditable(item)}
                  type="button"
                  className={classnames('week__day', {
                    'week__day--active': current === index,
                  })}
                  onClick={() => {
                    setCurrent(index);
                  }}
                >
                  {item.number ? (
                    <span className="week__day__number">{item.number}</span>
                  ) : null}

                  {item.title ? (
                    <span className="week__day__title">{item.title}</span>
                  ) : null}
                </button>
              </li>
            ))}
          </ul>

          <div className="week__details">
            {items.map((item, index) => {
              const isActive = current === index;
              const avatars = (item.avatars || []).filter(isImage);
              const hasBackground = isImage(item.background);

              return (
                <div
                  key={item._uid}
                  className={classnames('week__panel', {
                    'week__panel--active': isActive,
                  })}
                  aria-hidden={!isActive}
                >
                  {hasBackground ? (
                    <div className="week__panel__background">
                      <Image
                        image={item.background}
                        sizes="(max-width: 768px) 100vw, 60vw"
                      />
                    </div>
                  ) : (
                    <div className="week__panel__halo" aria-hidden="true" />
                  )}

                  <div className="week__panel__inner">
                    {item.banner ? (
                      <div className="week__panel__banner">
                        <span
                          className="week__panel__banner__dot"
                          aria-hidden="true"
                        />
                        <p className="week__panel__banner__text">
                          {item.banner}
                        </p>
                      </div>
                    ) : null}

                    <div className="week__panel__body">
                      {avatars.length > 0 ? (
                        <div
                          className={classnames(
                            'week__panel__avatars',
                            `week__panel__avatars--count-${Math.min(avatars.length, 5)}`,
                          )}
                        >
                          {avatars.map((avatar, idx) => (
                            <span
                              key={avatar.id || `${avatar.filename}-${idx}`}
                              className="week__panel__avatar"
                            >
                              <Image image={avatar} sizes="160px" />
                            </span>
                          ))}
                        </div>
                      ) : null}

                      {hasText(item.content) ? (
                        <div className="week__panel__content">
                          {render(item.content)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </MaxWidth>
    </div>
  );
};
